package com.solevo.dist.network.firebase.api.user.models

import com.solevo.dist.application.models.AllowPromotionalNotification
import com.solevo.dist.application.models.AllowedCustomer
import com.solevo.dist.application.models.User
import com.solevo.dist.application.models.UserType
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Created by Ilija Vucetic on 12.9.25..
 * Copyright (c) 2025 Aktiia. All rights reserved.
 */
@Serializable
data class FirebaseUser(
    val customerId: String = "",
    val firebaseUid: String = "",
    val contactId: String? = "",
    val legalEntityId: String? = null,
    val firstName: String = "",
    val lastName: String = "",
    var language: String = "",
    val phoneNumber: String = "",
    var pin: String? = null,
    val fcmToken: String? = null,
    val allowedCustomers: List<AllowedCustomer>? = null,
    val type: UserType? = UserType.Contact,
    @SerialName("isActive")
    val isActive: Boolean? = null,
    @SerialName("isManuallyImported")
    val isManuallyImported: Boolean? = null,
    val allowPromotionalNotifications: String? = AllowPromotionalNotification.NotSet.name
)

fun FirebaseUser.toUser(): User {
    return User(
        customerId = customerId,
        firebaseUid = firebaseUid,
        contactId = contactId,
        legalEntityId = legalEntityId,
        firstName = firstName,
        lastName = lastName,
        language = language,
        phoneNumber = phoneNumber,
        pin = pin,
        fcmToken = fcmToken,
        allowedCustomers = allowedCustomers,
        type = type,
        isActive = isActive,
        isManuallyImported = isManuallyImported,
        allowPromotionalNotifications = allowPromotionalNotifications
    )
}
